const ETAnchorType=["Threaded Rod","Headed Bolt","Headed Stud","Hooked Bolt"]

const iniTensileStrength=58e3
const iniEmbedDepth=6
const iniHookLength=2
const iniFc=4e3
const iniThickness=15

const RodProperties = [
    { label: '1/4"', Diameter: .25, Ase: .032, "Abrg Square": .142, "Abrg Heavy Square": .201, "Abrg Hex": .117, "Abrg Heavy Hex": .167 },
    { label: '3/8"', Diameter: .375, Ase: .078, "Abrg Square": .28, "Abrg Heavy Square": .362, "Abrg Hex": .164, "Abrg Heavy Hex": .299 },
    { label: '1/2"', Diameter: .5, Ase: .142, "Abrg Square": .464, "Abrg Heavy Square": .569, "Abrg Hex": .291, "Abrg Heavy Hex": .467 },
    { label: '5/8"', Diameter: .625, Ase: .226, "Abrg Square": .693, "Abrg Heavy Square": .822, "Abrg Hex": .454, "Abrg Heavy Hex": .671 },
    { label: '3/4"', Diameter: .75, Ase: .334, "Abrg Square": .824, "Abrg Heavy Square": 1.121, "Abrg Hex": .654, "Abrg Heavy Hex": .911 },
    { label: '7/8"', Diameter: .875, Ase: .462, "Abrg Square": 1.121, "Abrg Heavy Square": 1.465, "Abrg Hex": .891, "Abrg Heavy Hex": 1.188 },
    { label: '1"', Diameter: 1, Ase: .606, "Abrg Square": 1.465, "Abrg Heavy Square": 1.855, "Abrg Hex": 1.163, "Abrg Heavy Hex": 1.501 },
    { label: '1-1/8"', Diameter: 1.125, Ase: .763, "Abrg Square": 1.854, "Abrg Heavy Square": 2.291, "Abrg Hex": 1.472, "Abrg Heavy Hex": 1.851 },
    { label: '1-1/4"', Diameter: 1.25, Ase: .969, "Abrg Square": 2.288, "Abrg Heavy Square": 2.773, "Abrg Hex": 1.817, "Abrg Heavy Hex": 2.237 },
    { label: '1-3/8"', Diameter: 1.375, Ase: 1.16, "Abrg Square": 2.769, "Abrg Heavy Square": 3.3, "Abrg Hex": 2.199, "Abrg Heavy Hex": 2.659 },
    { label: '1-1/2"', Diameter: 1.5, Ase: 1.41, "Abrg Square": 3.295, "Abrg Heavy Square": 3.873, "Abrg Hex": 2.617, "Abrg Heavy Hex": 3.118 },
    { label: '1-3/4"', Diameter: 1.75, Ase: 1.9, "Abrg Square": 0, "Abrg Heavy Square": 0, "Abrg Hex": 0, "Abrg Heavy Hex": 4.144 },
    { label: '2"', Diameter: 2, Ase: 2.5, "Abrg Square": 0, "Abrg Heavy Square": 0, "Abrg Hex": 0, "Abrg Heavy Hex": 5.316 }]
  const BoltProperties = [
    { label: '1/4"', Diameter: .25, Ase: .032, "Abrg Square": .092, "Abrg Heavy Square": 0, "Abrg Hex": .117, "Abrg Heavy Hex": 0 },
    { label: '3/8"', Diameter: .375, Ase: .078, "Abrg Square": .206, "Abrg Heavy Square": 0, "Abrg Hex": .164, "Abrg Heavy Hex": 0 },
    { label: '1/2"', Diameter: .5, Ase: .142, "Abrg Square": .366, "Abrg Heavy Square": 0, "Abrg Hex": .291, "Abrg Heavy Hex": .467 },
    { label: '5/8"', Diameter: .625, Ase: .226, "Abrg Square": .572, "Abrg Heavy Square": 0, "Abrg Hex": .454, "Abrg Heavy Hex": .671 },
    { label: '3/4"', Diameter: .75, Ase: .334, "Abrg Square": .824, "Abrg Heavy Square": 0, "Abrg Hex": .654, "Abrg Heavy Hex": .991 },
    { label: '7/8"', Diameter: .875, Ase: .462, "Abrg Square": 1.121, "Abrg Heavy Square": 0, "Abrg Hex": .891, "Abrg Heavy Hex": 1.188 },
    { label: '1"', Diameter: 1, Ase: .606, "Abrg Square": 1.465, "Abrg Heavy Square": 0, "Abrg Hex": 1.163, "Abrg Heavy Hex": 1.501 },
    { label: '1-1/8"', Diameter: 1.125, Ase: .763, "Abrg Square": 1.854, "Abrg Heavy Square": 0, "Abrg Hex": 1.472, "Abrg Heavy Hex": 1.851 },
    { label: '1-1/4"', Diameter: 1.25, Ase: .969, "Abrg Square": 2.228, "Abrg Heavy Square": 0, "Abrg Hex": 1.817, "Abrg Heavy Hex": 2.237 },
    { label: '1-3/8"', Diameter: 1.375, Ase: 1.16, "Abrg Square": 2.769, "Abrg Heavy Square": 0, "Abrg Hex": 2.199, "Abrg Heavy Hex": 2.659 },
    { label: '1-1/2"', Diameter: 1.5, Ase: 1.41, "Abrg Square": 3.295, "Abrg Heavy Square": 0, "Abrg Hex": 2.617, "Abrg Heavy Hex": 3.118 },
    { label: '1-3/4"', Diameter: 1.75, Ase: 1.9, "Abrg Square": 0, "Abrg Heavy Square": 0, "Abrg Hex": 3.562, "Abrg Heavy Hex": 4.144 },
    { label: '2"', Diameter: 2, Ase: 2.5, "Abrg Square": 0, "Abrg Heavy Square": 0, "Abrg Hex": 4.653, "Abrg Heavy Hex": 5.316 }]
  const StudProperties = [
    { label: '1/4"', Diameter: .25, Ase: .049, Abrg: .147 },
    { label: '3/8"', Diameter: .375, Ase: .11, Abrg: .331 },
    { label: '1/2"', Diameter: .5, Ase: .196, Abrg: .589 },
    { label: '5/8"', Diameter: .625, Ase: .307, Abrg: .92 },
    { label: '3/4"', Diameter: .75, Ase: .442, Abrg: .785 },
    { label: '7/8"', Diameter: .875, Ase: .601, Abrg: .884 },
    { label: '1"', Diameter: 0, Ase: 0, Abrg: 0 },
    { label: '1-1/8"', Diameter: 0, Ase: 0, Abrg: 0 },
    { label: '1-1/4"', Diameter: 0, Ase: 0, Abrg: 0 },
    { label: '1-3/8"', Diameter: 0, Ase: 0, Abrg: 0 },
    { label: '1-1/2"', Diameter: 0, Ase: 0, Abrg: 0 },
    { label: '1-3/4"', Diameter: 0, Ase: 0, Abrg: 0 },
    { label: '2"', Diameter: 0, Ase: 0, Abrg: 0 }]
  

export default function AnchorBoltClass() {
    this.diameterIndex=0,
    this.anchorType=ETAnchorType[0],
    this.nutTypeIndex=0,
    this.nutType="Square",
    this.embedDepth=iniEmbedDepth,
    this.hookLength=iniHookLength,
    this.tensileStrength=iniTensileStrength,
    this.anchorsWelded=!1,
    this.groutPads=!1,
    this.fc=iniFc,
    this.thickness=iniThickness,
    this.barsCrossTensionFailure=!1,
    this.barsPreventTensionBreakout=!1,
    this.shearXNumber4Bars=!1,
    this.shearXStirrups=!1,
    this.shearXNoBreakout=!1,
    this.shearYNumber4Bars=!1,
    this.shearYStirrups=!1,
    this.shearYNoBreakout=!1
}

AnchorBoltClass.prototype.Init = function(anchorJSON) {
    var a=anchorJSON;
    this.diameterIndex=a.diameterIndex,
    this.anchorType=a.anchorType,
    this.nutType=a.nutType,
    this.embedDepth=a.embedDepth,
    this.hookLength=a.hookLength,
    this.tensileStrength=a.tensileStrength,
    this.anchorsWelded=a.anchorsWelded,
    this.groutPads=a.groutPads,
    this.fc=a.fc,
    this.thickness=a.thickness,
    this.barsCrossTensionFailure=a.barsCrossTensionFailure,
    this.barsPreventTensionBreakout=a.barsPreventTensionBreakout,
    this.shearXNumber4Bars=a.shearXNumber4Bars,
    this.shearXStirrups=a.shearXStirrups,
    this.shearXNoBreakout=a.shearXNoBreakout,
    this.shearYNumber4Bars=a.shearYNumber4Bars,
    this.shearYStirrups=a.shearYStirrups,
    this.shearYNoBreakout=a.shearYNoBreakout
}

AnchorBoltClass.prototype.IsAnchorHooked = function() {
    return "Hooked Bolt"===this.anchorType
}

AnchorBoltClass.prototype.IsHeadedStud = function() {
    return "Headed Stud"===this.anchorType
}

AnchorBoltClass.prototype.GetProperties = function() {
    switch(this.anchorType){
        case ETAnchorType[0]:return RodProperties;
        case ETAnchorType[1]:return BoltProperties;
        case ETAnchorType[2]:return StudProperties;
        case ETAnchorType[3]:return RodProperties
    }
}

AnchorBoltClass.prototype.GetDiameter = function() {
    return this.GetProperties()[this.diameterIndex].Diameter
}

AnchorBoltClass.prototype.GetArea = function() {
    return this.GetProperties()[this.diameterIndex].Ase
}

AnchorBoltClass.prototype.GetBearingArea = function() {
    var nutType=this.nutType;
    if(this.IsHeadedStud()){
        var Abrg=this.GetProperties()[this.diameterIndex].Abrg;
        return Abrg
    }
    
    var Abrg=this.GetProperties()[this.diameterIndex]["Abrg "+nutType];
    return Abrg
}
